import { __rest, __assign } from 'tslib';
import React__default, { forwardRef } from 'react';
import { Fab } from '@mui/material';
import clsx from 'clsx';
import { adaptHoverColor } from '../../utils/buttonStyle.js';

var KFab = forwardRef(function (_a, ref) {
    var className = _a.className, buttonName = _a.buttonName, _b = _a.testId, testId = _b === void 0 ? "KFab" : _b, sx = _a.sx, rest = __rest(_a, ["className", "buttonName", "testId", "sx"]);
    return (React__default.createElement(Fab, __assign({ ref: ref, color: "primary", className: clsx("KFab", className, buttonName && "KFab-".concat(buttonName)) }, rest, { sx: __assign({ "&:hover": {
                backgroundColor: function (theme) { return adaptHoverColor(theme.palette.primary.main); }
            } }, sx), "data-testid": testId })));
});

export { KFab as default };
//# sourceMappingURL=index.js.map
